import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getManagerPermissions } from '../../../store/settings/selectors';
import { getAuthenticateUser } from '../../../store/authenticate/selectors';
import { usePermissions } from '../../../hooks/useCommon';

export function useTeamPermissions() {
  const settings = useAppSelector(getManagerPermissions);
  const { personnel } = useAppSelector(getAuthenticateUser);
  const { permissions } = usePermissions(); // Other permission states like isAdmin, isEmployee

  const teamPermissions = useMemo(() => {
    const isManager = personnel.permissionLevel === 'Manager'; // Check if user is a manager

    const canViewTeam = get(settings, 'visibility.team.view');
    const canManageTeam = get(settings, 'actions.team.manage');
    const canViewSalaryData = get(settings, 'visibility.team.salaryData');

    return {
      isAllowManage: permissions.isAdmin || (isManager && canViewTeam && canManageTeam),
      isAllowViewSalaryData: permissions.isAdmin || (isManager && canViewTeam && canViewSalaryData),
    };
  }, [personnel.permissionLevel, settings, permissions]);

  return {
    teamPermissions,
  };
}
